import React, { Component } from 'react';
import { Form, Input, message, Modal, Select } from 'antd';

import { queryFinanceBooksInfo } from '@api/finance/finance';
import { queryCompany } from '@api/core/org';

const FormItem = Form.Item;
const { Option } = Select;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
      treeData: [],
      isProBudget: false,
    };
  }

  componentDidMount() {
    const { uuid } = this.props;
    this.loadCompany();
    if (uuid) {
      this.loadDetail(uuid);
    }
  }

  /**
   *获取组织列表
   */
  loadCompany = () => {
    const params = {};
    params.type = 1;
    queryCompany(params).then(res => {
      if (res.statusCode === 200) {
        const options = [];
        res.data.map(item => {
          const optionItem = {};
          optionItem.label = item.name;
          optionItem.value = item.uuid;
          optionItem.key = item.uuid;
          options.push(optionItem);
          return options;
        });
        this.setState({
          treeData: options,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  onLoadData = treeNode => {
    const arr = [];
    const key = treeNode.props.eventKey;
    const params = {};
    params.type = 1;
    params.uuid = key.split('-')[key.split('-').length - 1];
    return new Promise(resolve => {
      queryCompany(params).then(res => {
        if (res.statusCode === 200) {
          res.data.map(item => {
            const optionItem = {};
            optionItem.label = item.name;
            optionItem.value = item.uuid;
            optionItem.key = `${key}-${item.uuid}`;
            arr.push(optionItem);
            return arr;
          });
          const treeData = [...this.state.treeData];
          const loop = data => {
            data.forEach(item => {
              if (key.indexOf(item.key) === 0) {
                if (item.children) {
                  resolve();
                  loop(item.children);
                } else if (item.key === key) {
                  if (arr.length > 0) {
                    item.children = arr;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else if (arr.length === 0) {
                    item.isLeaf = true;
                    this.setState({ treeData }, () => {
                      resolve();
                    });
                  } else {
                    resolve();
                  }
                }
              }
            });
          };
          loop(treeData);
        }
      });
    });
  };

  handleCompany = (e, option) => {
    this.companyName = option[0];
    this.companyUuid = e;
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    const capital = this.props.form.getFieldsValue();
    capital.companyName = this.companyName || this.state.content.companyName;
    capital.companyUuid = this.companyUuid || this.state.content.companyUuid;
    delete capital.company;
    this.props.form.validateFields(err => {
      if (!err) {
        handSubmit(capital);
      }
    });
  };

  setCompanyName = (value, option) => {
    this.companyName = option.props.children;
    this.companyUuid = value;
  };

  loadDetail = uuid => {
    queryFinanceBooksInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          content: res.data,
        });
      }
    });
  };

  handleRadio = () => {
    const { isProBudget } = this.state;
    this.setState({
      isProBudget: !isProBudget,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { content } = this.state;

    return (
      <Modal
        title="新增预算组流水"
        visible
        onOk={this.submit}
        onCancel={this.props.cancel}
        footer={false}
      >
        <Form>
          <FormItem label="预算组名称" {...formItemLayout}>
            {getFieldDecorator('bookName', {
              rules: [{ required: true, message: '请输入账户名称' }],
              initialValue: content.bookName,
            })(<Input />)}
          </FormItem>
          <FormItem label="收支方向" {...formItemLayout}>
            {getFieldDecorator('pro', {
              rules: [{ required: true, message: '请选择收支方向' }],
              initialValue: content.bookName,
            })(
              <Select>
                <Option value="1">收入</Option>
                <Option value="2">支出</Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="预算类型" {...formItemLayout}>
            {getFieldDecorator('pro', {
              rules: [{ required: true, message: '请选择预算类型' }],
              initialValue: content.bookName,
            })(
              <Select>
                <Option value="1">收入</Option>
                <Option value="2">支出</Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="发生金额" {...formItemLayout}>
            {getFieldDecorator('pro', {
              rules: [{ required: true, message: '请输入发生金额' }],
              initialValue: content.bookName,
            })(
              <Select>
                <Option value="1">收入</Option>
                <Option value="2">支出</Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="摘要" {...formItemLayout}>
            {getFieldDecorator('pro', {
              rules: [{ required: true, message: '请输入摘要' }],
              initialValue: content.bookName,
            })(
              <Select>
                <Option value="1">收入</Option>
                <Option value="2">支出</Option>
              </Select>,
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/budget/check/ModalProgress.js